module.exports = __webpack_public_path__ + "img/Visa-512.39982736.png";